export default {
  brand: {
    leninka: "Leninka",
    artIp: "Art IP",
    digitalEnv: "digital environment of the Leninka Art project",
    digitalEnvShort: "digital environment of the Leninka Art project",
  },
  nav: {
    home: "Home",
    profile: "Profile",
    events: "Events",
    deposit: "Deposit",
    admin: "Administration",
    contacts: "Contacts",
    about: "About",
    login: "Sign in",
    loginMobile: "Sign in / Profile",
    logout: "Sign out",
    settings: "Settings",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    partnersGroup: "Partner logos",
    ailaEcosystemAria: "AILA, RGB ecosystem",
    platformLabel: "Platform",
    partnerAilaAlt: "AILA",
    partnerLeninkaArtAlt: "Leninka Art project logo",
    eventsMenuAria: "Events section menu",
    eventsMenuPanelHeading: "Schedule and event management",
    eventsMenu: {
      all: "All events",
      created: "My events",
      moderation: "Event moderation",
      registrations: "Participant moderation",
    },
  },
  footer: {
    portalTitle: "Ecosystem",
    infoTitle: "Information",
    aboutLibrary: "About us",
    contacts: "Contacts",
    personalDataConsent: "Consent to personal data processing",
    personalDataProcessingPolicy: "Personal data processing policy",
    tagline:
      "We help authors develop ideas, find like-minded people, and build an individual professional growth path.",
    copyright: "\u00a9 2026 Leninka IP. All rights reserved.",
    terms: "Terms of use",
    socialVk: "VK",
    socialTelegram: "Telegram",
    socialOk: "Odnoklassniki",
    socialMax: "MAX",
    socialZen: "Yandex Zen",
    socialLiveJournal: "LiveJournal",
    photoCreditsLead:
      "Photographs of the RSL building: Valeriy Shustov, Sergey Pyatakov (RIA Novosti), Alexey Troshin, Paul Grach. Source —",
    photoCreditsLicense: "CC BY-SA 3.0, CC BY 3.0, Public Domain",
  },
  common: {
    all: "All",
    more: "Learn more",
    openLink: "Open",
    register: "Register",
    close: "Close",
    cancel: "Cancel",
    searchCatalog: "Search the catalogue...",
    charLimit: "Character limit exceeded",
    or: "or",
    loading: "Loading...",
    opensInNewTab: "opens in a new tab",
    skipToContent: "Skip to content",
    pager: {
      navigation: "Pagination",
      previousPage: "Previous page",
      nextPage: "Next page",
    },
    datePicker: {
      prevMonth: "Previous month",
      nextMonth: "Next month",
      clearDate: "Clear date",
      selectDay: "Day",
      selectMonth: "Month",
      selectYear: "Year",
      selectPlaceholder: "—",
      calendarBirth: "Choose date of birth",
      calendarAchievement: "Choose achievement date",
      calendarWorkCreation: "Choose work creation date",
    },
    timePicker: {
      hours: "Hours",
      minutes: "Minutes",
    },
    table: {
      sortAria: "Sort: {{column}}, {{direction}}",
      sortDirectionAsc: "ascending",
      sortDirectionDesc: "descending",
      sortDirectionNone: "unsorted",
    },
  },
  breadcrumbs: {
    home: "Home",
    events: "Events",
    deposits: "Deposit",
    details: "Details",
  },
  home: {
    hero: {
      badge: "Leninka",
      badgeAccent: "Art IP",
      titleLine1: "Knowledge.",
      titleLine2: "Creativity.",
      titleLine3: "The future.",
      subtitle:
        "We help authors develop ideas, find like-minded people, and build an individual professional growth path.",
      quickEvents: "Events",
      quickDeposit: "Deposit",
      statYear: "founded",
      statReaders: "readers",
      imageAlt: "Lenin Library",
      scrollToQuickLinks: "Go to quick links",
    },
    directions: {
      kicker: "What we offer",
      title1: "MAIN",
      title2: "FOCUS AREAS",
      eventsTitle: "Events",
      eventsDesc:
        "Conferences, lectures, exhibitions, workshops, and hackathons. Take part and organise events.",
      depositTitle: "Deposit",
      depositDesc:
        "Official registration and protection of copyright for your works in the RSL collections.",
    },
    events: {
      kicker: "What\u2019s on",
      title: "Events",
      allLink: "All events",
      empty: "No upcoming events right now",
    },
    cta: {
      titleLine1: "Join the",
      titleLine2: "RSL community",
      subtitle:
        "Sign up to take part in events, grow your portfolio, and use the platform.",
      register: "Register",
      imageAlt: "Join us",
    },
  },
  aboutPage: {
    documentTitle: "About RSL",
    kicker: "Russian State Library",
    title: "About us",
    lead:
      "The Russian State Library is more than books and reading rooms. It is an open ecosystem of knowledge, culture, and technology where authors, researchers, and creative teams discover events, preserve their works, and build professional connections.",
    childSiteTitle: "RSL in the digital environment",
    childSiteBody1:
      "RSL digital services help people use the library's opportunities online: register for events, deposit works, confirm authorship, and interact with a professional community. The portal complements RSL offline programmes by moving key processes into a convenient digital environment.",
    missionTitle: "Mission",
    missionText:
      "We preserve cultural heritage and develop a space of the future where knowledge, authors' works, technology, and live events come together in one environment.",
    valuesTitle: "Values",
    values: {
      elite: "Preserving and opening knowledge for new generations",
      trends: "Supporting authors through deposits and digital services",
      environment: "Creating an environment for meetings, events, and future professionals",
    },
    orgTeamTitle: "RSL leadership",
    orgTeamIntro:
      "The Russian State Library leadership oversees the library's strategic development, scientific publishing, and educational programmes.",
    team: {
      director: "Vadim Duda \u2014 Director General",
      scientificPublishingDeputy: "Alexander Samarin \u2014 Deputy Director General for Scientific Publishing",
      scientificEducationDirector:
        "Ekaterina Dudareva \u2014 Director of the Department of Scientific and Educational Activities",
    },
    orgTeamCta: "Leadership on rsl.ru",
    expertCouncilTitle: "Expert and advisory bodies",
    expertCouncilIntro:
      "RSL's expert work is based on the library's official councils, regulations, and project bodies. They support the development of the library's research, collections, digital services, and public agenda.",
    experts: {
      scientificCouncil: {
        name: "RSL Scientific Council",
        role: "Scientific expertise, research development, and the library's professional agenda",
      },
      bookMonumentsCouncil: {
        name: "Expert Council on Book Monuments",
        role: "Expert assessment of rare and valuable documents connected with book heritage",
      },
    },
    expertCouncilMore:
      "Official regulations and documents about the councils are published in the RSL documents section.",
    expertCouncilCta: "RSL documents",
    ctaContacts: "Write to us",
  },
  contactsPage: {
    kicker: "Contact us",
    title: "Contacts",
    writeUs: "Write to us",
    sentTitle: "Message sent!",
    sentHint: "We will reply within 1\u20132 business days.",
    name: "Name",
    email: "Email",
    subject: "Subject",
    message: "Message",
    send: "Send message",
    address: "Address",
    phone: "Phone",
    emailBlock: "Email",
    hours: "Opening hours",
    officialPages: "Official pages",
    siteLabel: "LeninkaArt NGO website",
    socialNetworks: "Social networks",
    mapTitle: "RSL map",
    subjects: {
      general: "General question",
      events: "Events",
      deposit: "Deposit",
      tech: "Technical support",
      coop: "Partnership",
    },
  },
  legalPages: {
    agreementTitle: "User agreement \u2014 Leninka IP",
    personalTitle: "Consent to personal data processing \u2014 Leninka IP",
    privacyTitle: "Personal data processing policy \u2014 Leninka IP",
  },
  notFound: {
    title: "Page not found",
    hint: "Check the URL or return to the home page.",
    backHome: "Back to home",
  },
}
